import { useEffect } from "react";
import { useNavigate } from "react-router";

import { useAccount, useRefreshAccess } from "./useAccount.ts";

export const CheckoutCompletePage = () => {
  const { refetch, data } = useAccount();
  const navigate = useNavigate();
  const refreshAccess = useRefreshAccess();

  useEffect(() => {
    const timer = setInterval(refetch, 1000);
    return () => clearInterval(timer);
  }, [refetch]);

  const interactProduct = data?.products.find((p) => p.productKey === "interact");
  // for some reason the z.enum([...]) change broke it, can't be bothered publishing a new
  // version for now.
  const state = interactProduct?.subscription?.state as string | undefined;
  useEffect(() => {
    if (state === "active") {
      void refreshAccess().then(() => {
        void navigate("/settings/billing", { replace: true });
      });
    }
  }, [state, refreshAccess, navigate]);

  return <div>Waiting for subscription: {state ?? "unknown"}</div>;
};
